import styled from 'styled-components';
import Picklist from 'components/Picklist';

export const StyledPicklist = styled(Picklist)`
    width: 100%;
`;
